import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/bulk-offer-poshmark';

export default function Example() {
  return (
    <>
      <Head>
        <title>Bulk Offer to Likers on Poshmark</title>
        <meta
          name='description'
          content='Forget about spending so much time sending Offer to Likers manually and skip the laborious and time-consuming task with Poshmark’s Bulk Listing actions.'
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/bulk-offer-poshmark' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/bulk-offer-poshmark' />
        <meta property='og:title' content='Bulk Offer to Likers on Poshmark' />
        <meta
          property='og:description'
          content='Forget about spending so much time sending Offer to Likers manually and skip the laborious and time-consuming task with Poshmark’s Bulk Listing actions.'
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=4' />
        <meta property='article:published_time' content='2022-01-22T00:00:00.000Z' />
        <meta property='article:modified_time' content='2022-01-22T00:00:00.000Z' />
        <meta property='article:tag' content='Poshmark' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
